import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { cart } from "@/theme/Cart";

interface Subscriptions extends HTMLElement {
    enabled: boolean;
    domain: string;
    customerParam: string;
}

@Component
export class ProductMiniCart extends ThemeComponent {
    @Ref() miniCartClose!: HTMLDivElement;
    @Ref() miniCartTotal!: HTMLSpanElement;
    @Ref() miniCartNewItem!: HTMLElement;
    @Ref() checkoutButton!: HTMLAnchorElement;
    @Prop subscriptions!: Subscriptions;

    protected strings = this.dataset.strings? this.dataset.strings: '';
    protected subscriptionRecurring: HTMLInputElement|null = null;
    private hasSubscription: boolean[] = [];
    private itemCount: number = 0;

    /**
     * Initialise.
     */
    init() {
        this.$subscribe(cart.onChange, () => this.cartUpdated());

        this.$listen(this.miniCartClose, 'click', () => {
            this.classList.remove('is-active');
        });

        this.addedItem();
        this.closeCart();

        // Find in product form
        this.subscriptionRecurring = document.querySelector('[data-ref="subscriptionRecurring"]');
    }

    /**
     * Close Mini Cart.
    */
    addedItem() {
        document.addEventListener('cartAddedItem', () => {
            this.closeCart();
        });
    }

    getCookie(name: string) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {return match[2];}
    }

    rechargeCheck() {

        if (this.hasSubscription.includes(true)) {
            if (this.subscriptionRecurring && this.subscriptionRecurring.checked) { return; }
            // eslint-disable-next-line max-len
            let recharge_url = `https://checkout.rechargeapps.com/r/checkout?myshopify_domain=${this.subscriptions.domain}`;
            recharge_url += `&cart_token=${this.getCookie('cart')}`;

            if (this.subscriptions.customerParam) {
                recharge_url += `&${this.subscriptions.customerParam}`;
            }

            this.checkoutButton.href = recharge_url;
        }
    }

    cartUpdated() {
        this.itemCount = 0;

        for (const item of cart.items) {
            this.hasSubscription[this.itemCount] = false;

            if (item.properties &&
                (item.properties.shipping_interval_frequency && item.properties.shipping_interval_frequency > 0)
            ) {
                this.hasSubscription[this.itemCount] = true;
            }

            this.itemCount++;
        }

        this.rechargeCheck();
    }

    /**
     * Close Mini Cart.
     */
    closeCart() {
        let timeout = setInterval(() => {
            this.classList.remove('is-active');
            clearInterval(timeout);
        }, 5000);

        this.addEventListener('mouseover', () => {
            clearInterval(timeout);
        });

        this.addEventListener('mouseout', () => {
            timeout = setInterval(() => {
                this.classList.remove('is-active');
                clearInterval(timeout);
            }, 5000);
        });
    }
}
